import { handleBonusNotificationInfo } from '../../../common/handleBonusNotificationInfo';

export const bonusNotificationInfo = async ({ actionInfo, actionId }, { lang, syncClose, dispatch }) =>
    handleBonusNotificationInfo({ actionInfo, actionId, isConfirmation: true }, { lang, syncClose, dispatch });
